import { useRef, useCallback } from 'react';
import axios from 'axios';
import { API } from '@/App';

const SILENCE_DELAY = 15000; // 15 seconds

export const useSilenceTimer = ({ sessionRef, personalityRef, trainingLanguageRef, scenarioRef, isSessionActiveRef, isSendingRef, onAiMessage }) => {
  const silenceTimerRef = useRef(null);

  const clear = useCallback(() => {
    if (silenceTimerRef.current) {
      clearTimeout(silenceTimerRef.current);
      silenceTimerRef.current = null;
    }
  }, []);

  const triggerSilenceResponse = useCallback(async () => {
    if (!isSessionActiveRef.current || !sessionRef.current || !personalityRef.current || isSendingRef.current) {
      return;
    }

    isSendingRef.current = true;

    try {
      const response = await axios.post(`${API}/chat/message`, {
        session_id: sessionRef.current.id,
        message: '[SILENCE - Le répartiteur ne répond pas]',
        scenario_context: scenarioRef.current,
        personality: personalityRef.current.id,
        language: trainingLanguageRef.current,
        is_silence_trigger: true
      });

      if (response.data.response) {
        onAiMessage({
          speaker: 'citizen',
          text: response.data.response,
          timestamp: response.data.timestamp
        });
        // Note: silence timer restart is handled by TrainingChat useEffect (after TTS ends)
      }
    } catch (error) {
      console.error('Error triggering silence response:', error);
    } finally {
      isSendingRef.current = false;
    }
  }, [onAiMessage]);

  const start = useCallback(() => {
    clear();

    if (!isSessionActiveRef.current || !sessionRef.current || !personalityRef.current) {
      return;
    }

    silenceTimerRef.current = setTimeout(() => {
      triggerSilenceResponse();
    }, SILENCE_DELAY);
  }, [clear, triggerSilenceResponse]);

  return { start, clear };
};
